export enum PermissonEnum {
    ///Xem
    Read = 1,

    ///Viết
    Create = 2,

    ///Sửa
    Update = 4,

    ///Xóa
    Delete = 8,

    ///Biên tập
    Editing = 16,

    ///Tuyển sinh
    Admission = 32,

    /// Kế toán
    Accounting = 64,

    /// Đào tạo
    Training = 128,

    ///Công tác sinh viên
    Ctsv = 256,

    ///Cài đặt
    Setting = 1024,

    ///Toàn quyền chức năng
    Full = 1073741824,

    ///None
    Allow = 34359738368,
}

export enum ModuleEnum {
    /// <summary>
    /// Hồ sơ sinh viên
    /// </summary>
    Student = 1,

    StudentInfo = 11,

    /// <summary>
    /// Quản lý lớp
    /// </summary>
    Class = 2,

    /// <summary>
    /// Danh mục
    /// </summary>
    Category = 3,

    /// <summary>
    /// Cấu hình
    /// </summary>
    Config = 4,

    /// <summary>
    /// Quản lý trạng thái sinh viên
    /// </summary>
    StudentStatus = 5,

    /// <summary>
    /// Nhóm người dùng
    /// </summary>
    Role = 98,

    /// <summary>
    /// Quán lý người dùng
    /// </summary>
    User = 99,

    // Grade Management Module
    Subject = 20,
    ComponentScore = 21,
    SubjectScore = 22,
    ConductScore = 23,
    Transcript = 24,

    /// <summary>Miễn giảm học phí</summary>
    TuitionExemption = 25,
    MajorExemption = 26,

}
